// extracted by mini-css-extract-plugin
export default {"cloudContainer":"CloudSolutions_cloudContainer__cuawm","imgContainer":"CloudSolutions_imgContainer__Ke0PG"};